module.exports = __webpack_public_path__ + "img/big-min.d6246bec.jpg";